(function () {
  angular.module("akitabox.mobile.components", [
    "akitabox.mobile.components.qrCodeCard",
    "akitabox.mobile.components.workOrderCardMobile",
    "akitabox.mobile.components.header",
    "akitabox.mobile.components.footer",
    "akitabox.mobile.components.create-buttons",
    "akitabox.mobile.components.action-buttons",
  ]);
})();
